import { SelectOption } from '@/components/form-builder/form-builder.types';
import { PassingModeDto } from '@/types';
import { createStore, withProps } from '@ngneat/elf';

export interface PassingModeStateProps {
  response: any;
  dto: PassingModeDto;
  typeMarchersSelected: SelectOption[];
  passingModeTypeSelected: SelectOption | null;
  passingModeStepSelected: SelectOption | null;
}

export const passingModeInitialState: PassingModeStateProps = {
  response: [],
  dto: {
    libelle: '',
    type: null,
    etapes: null,
    restraint: false,
    typeMarchersIds: [],
  },
  typeMarchersSelected: [],
  passingModeTypeSelected: null,
  passingModeStepSelected: null,
};

export const passingModeStateStore = createStore(
  { name: 'passing-mode-state' },
  withProps<PassingModeStateProps>({
    ...passingModeInitialState,
  })
);
